export interface ProfileCategory {
	ProfileCategoryId: number;
	AssetId: number;
	Name: string;
	SortOrder: number;
	IsActive: boolean;
	ItemCount: number;
}

export interface ProfileItem {
	ProfileItemId: number;
	ProfileCategoryId: number;
	CategoryName: string;
	AssetId: number;
	Code: string;
	Name: string;
	DisplayName: string | null;
	ValueTypeCode: string;
	SortOrder: number;
	IsActive: boolean;
	ReferenceCount: number;
}

export interface ProfileItemFormValues {
	ProfileItemId: number | null;
	ProfileCategoryId: number | null;
	Code: string;
	Description: string;
	ValueTypeCode: string;
}

export const PROFILE_ITEM_INITIAL_VALUES: ProfileItemFormValues = {
	ProfileItemId: null,
	ProfileCategoryId: null,
	Code: "",
	Description: "",
	ValueTypeCode: "V",
};

export const PROFILE_ITEM_MODAL_MODE = {
	CLOSED: "",
	CREATE: "create",
	UPDATE: "update",
	DELETE: "delete",
} as const;

export type ProfileItemModalMode =
	(typeof PROFILE_ITEM_MODAL_MODE)[keyof typeof PROFILE_ITEM_MODAL_MODE];
